import {
  RewardRule,
  RewardRuleServiceType,
  SERVICE_TYPE_LABELS,
} from '../../../../rewards/models/rewards-v2.models';
import {
  formatRewardsUsd,
  REWARDS_ZERO_DISPLAY,
} from '../../../../rewards/utils/rewards-currency.util';

/** Same formatting as admin summary table (2 decimals, comma grouping). */
export function formatRewardRuleAmount(amount: number): string {
  return formatRewardsUsd(amount, { zeroDisplay: REWARDS_ZERO_DISPLAY });
}

const SERVICE_TYPE_DISPLAY: Record<RewardRuleServiceType, string> = {
  single_wash: 'Single Wash',
  membership: 'Membership',
  prepaid: 'Prepaid',
};

export function formatRewardRuleServiceType(serviceType: RewardRuleServiceType): string {
  return SERVICE_TYPE_DISPLAY[serviceType] ?? SERVICE_TYPE_LABELS[serviceType] ?? serviceType;
}

export function formatRewardRuleWashTypes(
  rule: RewardRule,
  packageNameById: ReadonlyMap<string, string>
): string {
  const ids = rule.selected_package_ids ?? [];
  if (ids.length === 0) {
    return '—';
  }

  const names = ids
    .map(id => packageNameById.get(id))
    .filter((name): name is string => Boolean(name));

  if (names.length === ids.length) {
    return names.join(', ');
  }

  if (names.length === 0) {
    return `${ids.length} selected`;
  }

  const more = ids.length - names.length;
  return `${names.join(', ')} and ${more} more`;
}

export function formatRewardRuleItemsRequired(itemsSold: number): string {
  return String(Number(itemsSold));
}
